import SearchStore, {FilterTaxDataType} from 'js/store/SearchStore';
import MixPanelWrapper from 'js/servises/MixPanelWrapper';
import {TaxonomyType} from 'js/containers/Pages/Search/SearchFilter/SearchFilterItem/SearchFilterItem';

class SearchFilterService {
    resetFilterSectionByParent(filterTaxData: FilterTaxDataType, entity: string):FilterTaxDataType {
        switch (entity) {
            case 'articles': filterTaxData['articleType'] = '';
                break;
            case 'videos': filterTaxData['videoType'] = '';
                break;
            case 'courses': filterTaxData['courseType'] = '';
                break;
            case 'manuals': filterTaxData['manualsType'] = '';
                break;
            default : return filterTaxData;
        }
        return filterTaxData;
    }
    async filterItemClickHandler(e, taxonomyName, anchor, type, heading, isAISearch) {
        const { filterEntitiesData, filterTaxData, searchQuery } = SearchStore;
        const { checked } = e?.target;
        const targetName = taxonomyName === 'productLegacy' ? e?.target?.value : e?.target?.name;

        if (searchQuery) {
            SearchStore.setSearchStatus(false);
            SearchStore.setSearchPage(1);
        }

        if (checked) {
            await MixPanelWrapper.TrackEvent('Search Filtering', {
                category: 'Search Filters',
                type: heading,
                value: e?.target?.dataset?.label,
                searchType: isAISearch ? 'AI' : 'Regular'
            });
        }

        anchor();
        let filterTaxDataCopy = { ...filterTaxData };

        if (type === 'entities') {
            const entitiesArray:string[] = filterEntitiesData ? filterEntitiesData.split(',') : [];
            let updatedEntitiesData:string[] = [];

            if (checked) {
                updatedEntitiesData = [...entitiesArray, targetName];
            } else {
                updatedEntitiesData = entitiesArray.filter(entityName => entityName !== targetName);
                filterTaxDataCopy = this.resetFilterSectionByParent(filterTaxDataCopy, targetName);
                SearchStore.setFilterTaxData(filterTaxDataCopy);
            }

            SearchStore.setFilterEntitiesData(updatedEntitiesData.join(','));
            return;
        }


        if (taxonomyName === 'productLegacy') {
            filterTaxDataCopy[taxonomyName] = targetName;
            filterTaxDataCopy['subjectMatter'] = '';
        } else {
            let currentTaxData = [];
            if (filterTaxDataCopy[taxonomyName]?.length > 0) {
                currentTaxData = filterTaxDataCopy[taxonomyName]?.split(',') || [];
            }
            if (checked) {
                filterTaxDataCopy[taxonomyName] = [...currentTaxData, targetName].join(',');
            } else {
                filterTaxDataCopy[taxonomyName] = currentTaxData.filter(name => name !== targetName).join(',');
            }
        }

        SearchStore.setFilterTaxData(filterTaxDataCopy);
    }

    quickSort(arr) {
        if (arr.length < 2) return arr;

        const pivot = arr[0];
        const left = [];
        const right = [];

        for (let i = 1; i < arr.length; i++) {
            if (arr[i]?.count > pivot?.count) {
                left.push(arr[i]);
            } else {
                right.push(arr[i]);
            }
        }

        return [...this.quickSort(left), pivot, ...this.quickSort(right)];
    }

    removeItemFromState(taxonomyName, itemId, type) {
        if (SearchStore.isSearchTransferData) {
            return;
        }

        if (type === 'taxonomy') {
            const currentTaxData = SearchStore.filterTaxData[taxonomyName];
            if (currentTaxData?.split(',')?.some(id => parseInt(id) === parseInt(itemId))) {
                SearchStore.setFilterTaxData({ ...SearchStore.filterTaxData, [taxonomyName]: '' });
            }
            return;
        }

        const entitiesStr = SearchStore.filterEntitiesData;
        if (!entitiesStr) return;

        const updatedEntitiesData = entitiesStr?.split(',')
            .filter(entityName => SearchStore.entitiesCounts?.some(el => el?.name === entityName && el?.count));

        SearchStore.setFilterEntitiesData(updatedEntitiesData.join(','));
    }

    getFilterCheckedCount(type: 'entities' | 'taxonomy', taxonomyName: TaxonomyType):number {
        let data = [];
        if (type === 'entities') {
            data = SearchStore.filterEntitiesData?.split(',')?.filter(item => item?.trim() !== '');
            return data?.length || 0;
        }
        data = SearchStore.filterTaxData[taxonomyName]?.split(',')?.filter(item => item?.trim() !== '');
        return data?.length || 0;
    }
}

export default new SearchFilterService();
